var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.69238H15",
    stroke: "#FF5151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.69238H13.25V15.7693C13.25 16.0957 13.127 16.4088 12.9083 16.6396C12.6895 16.8704 12.3927 17.0001 12.0833 17.0001H3.91667C3.60724 17.0001 3.3105 16.8704 3.09171 16.6396C2.87292 16.4088 2.75 16.0957 2.75 15.7693V4.69238Z",
    stroke: "#FF5151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08398 4.69231V4.07692C5.08398 3.26087 5.39127 2.47824 5.93825 1.90121C6.48523 1.32417 7.2271 1 8.00065 1C8.7742 1 9.51607 1.32417 10.063 1.90121C10.61 2.47824 10.9173 3.26087 10.9173 4.07692V4.69231",
    stroke: "#FF5151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.38647V13.3114",
    stroke: "#FF5151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.38647V13.3114",
    stroke: "#FF5151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMenu);
export default __webpack_public_path__ + "static/media/remove-menu.34bc5b93ec4de8c9af7ddec42a252f44.svg";
export { ForwardRef as ReactComponent };